export default {
  Providers: {
    App: 'providers.app',
    TokenLists: 'providers.tokenLists',
    Tokens: 'providers.tokens',
    Staking: 'providers.staking',
    JoinPool: 'provider.joinPool',
    ExitPool: 'provider.exitPool',
    PoolStaking: 'provider.poolStaking',
    PoolPointsStaking: 'provider.poolPointsStaking',
    UserStaking: 'provider.userStaking',
    UserData: 'provider.userData',
    UserPools: 'provider.userPools',
    Wallets: 'provider.wallets',
    Pool: 'provider.pool',
    UserTokens: 'provider.userTokens',
    CrossChainSync: 'provider.crossChainSync',
    Voting: 'provider.voting',
  },
};
